import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Account } from 'app/constants/account.enum';
import { TransportAssocService } from 'app/services/transport-assoc.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CarrierService } from 'app/services/carrier.service';
import { DialogService } from 'ng2-bootstrap-modal';
import { AlertComponent } from 'app/popup/alert.component';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'compliance',
  templateUrl: './compliance-legal.component.html',
  styleUrls: ['./compliance-legal.component.css']
})
export class ComplianceLegalComponent implements OnInit {
  @Input('ctrlPages') ctrlPages: any;  
  lblHeading: string = "Compliance and Legal";
  isLoading = false;
  message = "Processing, please wait...";
  displayIndicators = [{ key: 1, value: 'TGF Supreme' }, { key: 2, value: 'Legal Transport' }]
  acc = Account;
  listAssoc: any = [];
  form;
  carrierCL:any = {};


  constructor(private transportAssocService: TransportAssocService,
     private carrierService: CarrierService,  public utility: UtilityServiceService,private toastr: ToastrService) { }

  ngOnInit() {
    this.createForm();
    
    this.lblHeading = (!this.utility.ctrlPages[Account.First].isEdit) ? "New Carrier Account's Compliance and Legal" : "Edit Carrier Account's Compliance and Legal";

    //this.listDDL();
    //if (this.utility.ctrlPages[Account.First].carrierId) {
    //  this.carrierAcc(this.utility.ctrlPages[Account.First].carrierId);

    //}
    //else {
    //  this.dialogService.addDialog(AlertComponent, { title: 'Retrieving carrier account information', message: 'Could not retrieve carrier account information.'});
    //}

  }
  
  createForm = ()=> {
    this.form = new UntypedFormGroup({
      carrier_id: new UntypedFormControl()
      , bbbee_status: new UntypedFormControl(this.carrierCL.bbbee_status, Validators.maxLength(12))      
      , csd_number: new UntypedFormControl(this.carrierCL.csd_number, Validators.maxLength(20))
      , assoc_id: new UntypedFormControl(this.carrierCL.assoc_id)
      , country: new UntypedFormControl(this.carrierCL.country)
      });    
  }

  initForm = (acc:any) => {
    (<UntypedFormGroup>this.form)
      .setValue({
          carrier_id: acc.carrier_id
        , bbbee_status: acc.bbbee_status
        , csd_number: acc.csd_number
        , assoc_id:acc.assoc_id
        , country: acc.country

      }, { onlySelf: true });
  }


  onSubmit = (obj: any) => {
    this.isLoading = true;
    this.carrierService.processCLegal(obj).subscribe(result => {
      this.carrierCL = result;
      this.isLoading = false;
      // this.dialogService.addDialog(AlertComponent, { title: `Carrier Account's Compliance and Legal`, message: `Carrier Account ${this.carrierCL.carrier_name}'s Compliance and Legal processed successfully.`, bold: `${this.carrierCL.carrier_name}` });
      this.toastr.success(`Carrier Account ${this.carrierCL.carrier_name}'s Compliance and Legal processed successfully.`,`Carrier Account's Compliance and Legal`);

    }, error => {
      this.isLoading = false;
      // this.dialogService.addDialog(AlertComponent, { title: `Carrier Account's Compliance and Legal`, message: `Carrier Account ${this.carrierCL.carrier_name}'s Compliance and Legal could not be processed successfully.`, bold: `${this.carrierCL.carrier_name}` });
      this.toastr.error(`Carrier Account ${this.carrierCL.carrier_name}'s Compliance and Legal could not be processed successfully.`,`Carrier Account's Compliance and Legal`);
    });
  }

  listDDL = () => {    
    this.transportAssocService.listTransportAssoc().subscribe(result => {
      this.listAssoc = result;      
      //console.log(this.listAssoc);      
    }, error => {      
      //console.log(error);
    });
  }

  carrierAcc = (id: number) => {
    this.isLoading = true;
    this.carrierService.carrierAccountsById(id).subscribe(result => {
      this.carrierCL = result;
      this.initForm(this.carrierCL);
      //console.log(this.carrierCL);
      this.isLoading = false;
    }, error => {
      this.isLoading = false;     
      //console.log(error);
    });
  }


  
}
